import { Component } from "@angular/core";
import { ComponentBase } from '../../../helpers/ComponentBase';
import { ApplicationService } from '../../../services/application.service';
import { PlatformService } from '../../../services/platform.service';
import { BatteryService } from '../../battery/services/battery.service';

@Component({ template: "" })
export abstract class AppComponentBase extends ComponentBase {

	//#region METHODS

	constructor(
		psvcApplication: ApplicationService,
		psvcPlatform: PlatformService,
		psvcBattery: BatteryService
	) {
		super();
		psvcApplication.markAppStart();

		if (psvcPlatform.isMobileApp) {
			psvcBattery.logOnLowBattery();
			psvcApplication.logOnPause();
			psvcApplication.logOnResume();
		}
	}

	//#endregion

}
